import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { Spin, Icon, Message, Upload } from 'antd';
import 'katex/dist/katex.min.css';
import katex from 'katex';
import less from './ExamPaperSplitRecord.less';
import './ExamPaperSplitRecord.css';
import account from '@/common/account/index';
import ProjectExperienceCanvas from '../ProjectExperienceCanvas';
import { fetchIdentifyResult } from '../../../api/demonstration';

const indicator = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const urlRegexp = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;
const selectList = ['识别结果', 'Response'];
const ReactJson = dynamic(import('react-json-view'), { ssr: false });

class ExamPaperSplitRecord extends React.Component {
  constructor() {
    super();
    this.state = {
      currentIndex: 0,
      imgDom: '',
      response: {},
      resultList: [],
      spinning: false,
      currentImageIndex: 0,
      inputUrl: '',
      imageErrorMsg: '',
      textRef: ''
    };
    this.handleTabClick = this.handleTabClick.bind(this);
    this.identifyImage = this.identifyImage.bind(this);
    this.fetchIdentifyResult = this.fetchIdentifyResult.bind(this);
    this.initState = this.initState.bind(this);
    this.inputOnChange = this.inputOnChange.bind(this);
    this.setUploadProps = this.setUploadProps.bind(this);
    this.identifyResultsShowing = this.identifyResultsShowing.bind(this);
    this.judgeImageSizeByUrl = this.judgeImageSizeByUrl.bind(this);
    this.handleImageErrorMsg = this.handleImageErrorMsg.bind(this);
  }

  handleTabClick(index) {
    this.setState({
      currentIndex: index
    });
    this.state.textRef.innerHTML = '';
  }

  initState() {
    this.setState({
      currentIndex: 0,
      imgDom: '',
      response: {},
      resultList: [],
      spinning: false,
      imageErrorMsg: ''
    });
  }

  handleImageErrorMsg(msg) {
    this.initState();
    this.state.textRef.innerHTML = '';
    this.setState({
      imageErrorMsg: msg
    });
  }

  hasAlphaPromise = (file) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      const fileReader = new FileReader();
      fileReader.onload = (f) => {
        image.src = f.target.result;
      };
      fileReader.readAsDataURL(file);
      let hasAlphaPixels = false;
      image.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = 851;
        canvas.height = 509;
        const context = canvas.getContext('2d');
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        let { data } = context.getImageData(0, 0, canvas.width, canvas.height);
        for (let i = 3, n = data.length; i < n; i += 4) {
          if (data[i] < 255) {
            hasAlphaPixels = true;
            break;
          }
        }
        if (hasAlphaPixels) {
          resolve(hasAlphaPixels);
        } else {
          reject();
        }
      };
      image.onerror = () => {
        reject();
      };
    });
  };

  setUploadProps() {
    const uploadProps = {
      supportServerRender: true,
      accept: 'image/jpg, image/jpeg, image/png,',
      name: 'file',
      showUploadList: false,
      beforeUpload: (file) => {
        if (file.size > 2048000) {
          this.handleImageErrorMsg('图片文件过大，请选择2MB以下的图');
        } else if (file.type === 'image/png') {
          this.hasAlphaPromise(file)
            .then((result) => {
              if (result) {
                this.handleImageErrorMsg(
                  '当前图片含透明通道，请选择jpg、 jpeg、png（不带透明通道）格式的图片'
                );
              }
            })
            .catch(() => {
              this.identifyImage(undefined, file, 0);
            });
        } else {
          this.identifyImage(undefined, file, 0);
        }
      }
    };
    return uploadProps;
  }

  fetchIdentifyResult(imageUrl, imagedata) {
    this.setState({
      spinning: true
    });
    const formdata = new FormData();
    if (imageUrl !== '') {
      formdata.append('url', imageUrl);
    } else {
      formdata.append('file', imagedata);
    }
    let userId = null;
    const loginEd = account.hasLoggedin();
    if (loginEd) userId = localStorage.getItem('userId') || null;
    formdata.append('userId', userId);
    fetchIdentifyResult(formdata)
      .then((data) => {
        if (data.code.toString() === '20000') {
          let { Data } = data.data;
          let newDataItemList = [];
          let newResultList = [];
          if (Data && Data.length > 0) {
            Data.forEach((dataItem) => {
              let dataItemList = Object.entries(dataItem);
              dataItemList = dataItemList.filter((item) => isNaN(item[1]));
              newDataItemList = [...dataItemList].sort((a, b) => {
                if (
                  parseInt(a[0].split('item')[1], 0) >
                  parseInt(b[0].split('item')[1], 0)
                ) {
                  return 1;
                }
                if (
                  parseInt(a[0].split('item')[1], 0) <
                  parseInt(b[0].split('item')[1], 0)
                ) {
                  return -1;
                }
                return 0;
              });
              newResultList.push(...newDataItemList);
            });
            if (newResultList.length === 0) {
              this.handleImageErrorMsg('未检测到题目，请更换图片');
            }
            this.setState({
              response: data,
              resultList: [...newResultList],
              spinning: false
            });
          } else {
            this.handleImageErrorMsg('未检测到题目，请更换图片');
          }
        }
      })
      .catch((error) => {
        this.setState({
          spinning: false,
          imageErrorMsg: error.msg || error.message
        });
      });
  }

  judgeImageSizeByUrl(url) {
    let blob = new Blob([url]);
    if (blob.size > 2048) {
      this.handleImageErrorMsg('图片文件过大，请选择2MB以下的图');
      return false;
    }
  }

  identifyImage(e, image, index) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    let imageUrl = '';
    let imageFile = '';
    const Dom = document.createElement('IMG');
    Dom.onload = () => {
      this.setState({
        imgDom: Dom
      });
    };
    if (image === '') {
      Message.error('请输入图片url');
      return false;
    }
    if (urlRegexp.test(image)) {
      if (
        !(
          image.indexOf('.jpg') !== -1 ||
          image.indexOf('.jpeg') !== -1 ||
          image.indexOf('.png') !== -1
        )
      ) {
        Message.error('请输入正确的图片url');
        return;
      }
      this.judgeImageSizeByUrl(image);
      imageUrl = image;
      Dom.src = image;
    } else {
      imageFile = image;
      const fileReader = new FileReader();
      fileReader.onload = (file) => {
        Dom.src = file.target.result;
      };
      fileReader.readAsDataURL(image);
    }
    this.setState({
      currentImageIndex: index
    });
    this.initState();
    this.state.textRef.innerHTML = '';
    this.fetchIdentifyResult(imageUrl, imageFile);
  }

  inputOnChange(e) {
    this.setState({
      inputUrl: e.target.value
    });
  }

  identifyResultsShowing(text, index) {
    if (!this.state.textRef) {
      return false;
    }
    let katexText = text.replace(/(\\n)/g, '\\n\\\\');
    katexText = katexText.replace(/\$\$/g, '  ');
    const pElement = document.createElement('p');
    const spanElementIndex = document.createElement('span');
    spanElementIndex.innerHTML = '【' + (index + 1) + '】';
    pElement.appendChild(spanElementIndex);
    const spanElement = document.createElement('span');
    katex.render(katexText || '', spanElement, {
      throwOnError: false,
      errorColor: '#042044',
      strict: 'ignore'
    });
    pElement.appendChild(spanElement);
    this.state.textRef.appendChild(pElement);
  }

  componentDidMount() {
    this.identifyImage(1, this.props.contents[0].image, 0);
  }

  render() {
    let { contents } = this.props;
    let { imgDom, spinning, currentImageIndex, inputUrl, imageErrorMsg } =
      this.state;
    return (
      <Spin indicator={indicator} spinning={spinning}>
        <div className={less.ExamPaperSplitRecord}>
          <div className={less.left}>
            <div className={less.imageResult}>
              {imageErrorMsg !== '' ? (
                <div className={less.image + ' ' + less.imageError}>
                  {imageErrorMsg}
                </div>
              ) : (
                <div className={less.image}>
                  <ProjectExperienceCanvas
                    backgroundImg={imgDom}
                    width="851"
                    height="509"
                    dataList={this.state.resultList}
                  />
                </div>
              )}
            </div>
            <div className={less.imgList}>
              {contents.length > 0 &&
                contents.map((content, index) => {
                  return (
                    <img
                      src={content.image}
                      alt="方案体验"
                      key={content.image}
                      className={
                        less.imageItem +
                        ' ' +
                        (currentImageIndex === index
                          ? less.activeImageItem
                          : '')
                      }
                      onClick={(e) =>
                        this.identifyImage(e, content.image, index)
                      }
                    />
                  );
                })}
            </div>
            <div className={less.imgUpload}>
              <div className={less.detection}>
                <input
                  className={less.input}
                  placeholder="请输入图片URL"
                  onChange={(e) => this.inputOnChange(e)}
                />
                <button
                  type="button"
                  className={less.button}
                  onClick={(e) => {
                    const loginEd = account.hasLoggedin();
                    if (!loginEd) {
                      window.location.href = `/account/login?from=${window.location.pathname}${window.location.search}`;
                      return;
                    }
                    this.identifyImage(e, inputUrl, 0);
                  }}
                >
                  检测
                </button>
              </div>
              <Upload {...this.setUploadProps()}>
                <div
                  className={less.uploadButton}
                  onClick={() => {
                    const loginEd = account.hasLoggedin();
                    if (!loginEd) {
                      window.location.href = `/account/login?from=${window.location.pathname}${window.location.search}`;
                    }
                  }}
                >
                  本地文件
                </div>
              </Upload>
            </div>
          </div>
          <div className={less.right}>
            <div className={less.result}>
              <div className={less.tab}>
                <div className={less.title}>
                  {selectList.length > 0
                    ? selectList.map((item, index) => {
                        return (
                          <p
                            key={item}
                            onClick={() => this.handleTabClick(index)}
                            className={
                              this.state.currentIndex === index
                                ? less.activeTitle
                                : ''
                            }
                          >
                            {item}
                          </p>
                        );
                      })
                    : null}
                </div>
                {
                  <div
                    className={
                      less.panel +
                      ' ' +
                      (this.state.currentIndex === 1 ? less.panelDisplay : '')
                    }
                    ref={(e) => (this.state.textRef = e)}
                  >
                    {this.state.resultList.length > 0 &&
                      this.state.resultList.map((textItem, index) => {
                        return this.identifyResultsShowing(
                          textItem[1].text.join(' '),
                          index
                        );
                      })}
                  </div>
                }
                {this.state.currentIndex === 1 && (
                  <div className={less.panel}>
                    <ReactJson src={this.state.response} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Spin>
    );
  }
}

ExamPaperSplitRecord.propTypes = {
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string
    })
  )
};

export default ExamPaperSplitRecord;
